import usePDPBasicDetails from '../context/usePDPBasicDetails';
import usePdpSelectedOptionsVariantSku from '../pdpSelectedOptionsVariantSku/usePdpSelectedOptionsVariantSku';

const usePdpFullVariantSku = () => {
  const basicDetails = usePDPBasicDetails();
  const optionsVariantSku = usePdpSelectedOptionsVariantSku();

  const baseSku = basicDetails?.data?.sku || '';

  if (!baseSku || !optionsVariantSku) {
    return null;
  }

  return `${baseSku}${optionsVariantSku}`;
};

export default usePdpFullVariantSku;
